import cloneDeep from 'lodash/cloneDeep';

import { ActionTypes, ActionsUnion } from './ui.actions';
import { TUISettings } from './ui.model';

export const initialState: TUISettings = {
  sitePlanWidth: {},
};

let newState: TUISettings = {
  sitePlanWidth: {},
};

export function uiReducer(state: TUISettings = initialState, action: ActionsUnion): TUISettings {
  switch (action.type) {
    case ActionTypes.SET_SITE_PLAN_WIDTH:
      newState = cloneDeep(state);

      newState.sitePlanWidth[action.payload.workspaceId] = +action.payload.width;

      return newState;

    case ActionTypes.SET_SITE_PLAN_WIDTH_FROM_DB:
      newState = cloneDeep(state);

      newState.sitePlanWidth = action.payload.sitePlanWidth;

      return newState;

    default:
      return state;
  }
}
